import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddNewDriver } from '../models/add-new-driver.model';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Pagination, Response } from '../../../_shared/models';
import { DriverInformation } from '../models/driver-information.model';
import { DriverInformationPaginationRequest } from '../../../_shared/models/drivers/management/driver-information-pagination-request.mode';
import { AssignedVehiclesCount, DriverInformationDetailed } from '../models/driver-detailed-information.model';
import { DriverTripOverview } from '../models/driver-trip-overview.model';
import { DriverInformationSettings, GlobalDriverSettings } from '../../../_shared/models/drivers/management/driver-information-settings.model';

@Injectable({
  providedIn: 'root'
})
export class DriverInformationService {

  constructor(private http: HttpClient) { }

  public createNewDriver(request: FormData): Promise<Response<AddNewDriver>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverinformation/add-driver-information`, request));
  }

  public getDriversListInformationDetail(request: DriverInformationPaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<DriverInformation[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverinformation/paginated-drivers`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverInformationDetail(id: number, cancellation: Subject<void>): Promise<Response<DriverInformationDetailed>> {
    return firstValueFrom(this.http.get(`${environment.apiEndpoint}/driverinformation/driver-information/id?id=${id}`).pipe(takeUntil(cancellation)));
  }

  public getAssignedVehiclesCount(driverId: number, cancellation: Subject<void>): Promise<Response<AssignedVehiclesCount>> {
    return firstValueFrom(this.http.get(`${environment.apiEndpoint}/driverinformation/assigned-vehicles/${driverId}`).pipe(takeUntil(cancellation)));
  }

  public getDriverTripOverview(driverId: number, cancellation: Subject<void>): Promise<Response<DriverTripOverview>> {
    return firstValueFrom(this.http.get(`${environment.apiEndpoint}/driverinformation/trips-overview/id?id=${driverId}`).pipe(takeUntil(cancellation)));
  }

  public updateDriverInformationDetail(request: FormData): Promise<Response<string>> {
    return firstValueFrom(this.http.post<Response<string>>(`${environment.apiEndpoint}/driverinformation/update-driver-information`, request));
  }

  public deleteDriver(driverId: number): Promise<Response<string>> {
    return firstValueFrom(this.http.delete<Response<string>>(`${environment.apiEndpoint}/driverinformation/${driverId}`));
  }

  public upsertDriverSettings(driverSettings: DriverInformationSettings): Promise<Response<DriverInformationSettings>> {
    return firstValueFrom(this.http.post<Response<any>>(`${environment.apiEndpoint}/DriverSettings/upsert-driver-settings`, driverSettings));
  }

  public getDriverSettings(driverId: number, cancellation: Subject<void>): Promise<Response<DriverInformationSettings>> {
    return firstValueFrom(this.http.get(`${environment.apiEndpoint}/driversettings/driver-settings/${driverId}`).pipe(takeUntil(cancellation)));
  }

  public getGlobalDriverSettings(cancellation: Subject<void>): Promise<Response<GlobalDriverSettings>> {
    return firstValueFrom(this.http.get((`${environment.apiEndpoint}/driversettings/global-driver-settings`)).pipe(takeUntil(cancellation)));
  }
}